import apiService from './api.service';
import {
  DashboardSummary,
  DashboardTrends,
  DashboardAlerts,
  DashboardParams,
} from '../types/dashboard.types';

class DashboardService {
  /**
   * Get summary metrics for the dashboard hero section.
   * Returns compliance rate, violation counts, and usage metrics.
   */
  async getSummary(params?: DashboardParams): Promise<DashboardSummary> {
    const response = await apiService.client.get<DashboardSummary>(
      '/dashboard/summary',
      { params: { period_days: params?.period_days } }
    );
    return response.data;
  }

  /**
   * Get time-series data for trend visualization.
   * Returns daily data points with call count and compliance rate.
   */
  async getTrends(params?: DashboardParams): Promise<DashboardTrends> {
    const response = await apiService.client.get<DashboardTrends>(
      '/dashboard/trends',
      { params: { period_days: params?.period_days } }
    );
    return response.data;
  }

  /**
   * Get alerts for compliance violations requiring attention.
   * Returns alerts sorted by severity (critical first).
   */
  async getAlerts(params?: DashboardParams): Promise<DashboardAlerts> {
    const response = await apiService.client.get<DashboardAlerts>(
      '/dashboard/alerts',
      { params: { period_days: params?.period_days } }
    );
    return response.data;
  }
}

export default new DashboardService();
